import {useGetPaymentsV1CMQuery, useGetPurchasesV1CMQuery} from "../../core/api/clockmaker-analytical-data-api";
import Loading from "../../components/Common/Loading";
import {DataGrid} from "@mui/x-data-grid";
import { useState } from "react"

const columns = [
    {
        headerName: "ID",
        field: "userFk",
        flex: 1
    },
    {
        headerName: 'item_id',
        field: 'itemId',
        flex: 1
    },
    {
        headerName: 'item_name',
        field: 'itemName',
        flex: 1
    },
    {
        headerName: 'price_cents',
        field: 'priceCents',
        flex: 1
    },
    {
        headerName: 'currency',
        field: 'currency',
        flex: 1
    },
    {
        headerName: 'purchase_verified',
        field: 'purchaseVerified',
        flex: 1
    },
    {
        headerName: 'last_level',
        field: 'lastLevel',
        flex: 1
    },
    {
        headerName: 'current_level',
        field: 'currentLevel',
        flex: 1
    },
    {
        headerName: 'app_name',
        field: 'appName',
        flex: 1
    },
    {
        headerName: 'timestamp',
        field: 'timestamp',
        flex: 1
    },
]

const InAppCM = (props) => {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100
    })

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetPurchasesV1CMQuery({
        "userId": props.deviceId,
        "depth": props.depth,
        "page": paginationModel.page,
        "limit": paginationModel.pageSize
    }, {
        skip: !props.deviceId || props.deviceId.trim() === ""
    })

    let payments = ""

    if (typeof data === "object") {

        payments = <DataGrid
            getRowId={(row) => row.itemId+row.timestamp}
            rows={data}
            rowCount={-1}
            columns={columns}
            pagination={true}
            paginationMode="server"
            pageSizeOptions={[100]}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            autoHeight

        />
    } else {
        payments = "no data"
    }

    return (
        <Loading
            isLoading={isLoading||isFetching}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            {payments}

        </Loading>
    )
}

export default InAppCM
